// extracted by mini-css-extract-plugin
export default {"info":"info_info__kcAcJ","container":"info_container__8n1Gr","box1":"info_box1__HbJn2","box2":"info_box2__wXmJm","card":"info_card__ZFexI","box1_section":"info_box1_section__QOjiu"};